import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from 'assets/images/logo.svg';


function MyProfile() {
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.auth?.user);

  //   const user = {
  //     name: "John Doe",
  //     email: "john@example.com",
  //     phone: "+1 234 567 890",
  //     role: "Administrator",
  //     joinDate: "2024-02-15",
  //     avatar: "https://via.placeholder.com/150",
  //     stats: {
  //       projects: 24,
  //       tasks: 120,
  //       meetings: 15,
  //     },
  //   };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container mt-5">
        {/* Profile Header */}
        <div
          className="rounded shadow-lg text-white p-4 mb-4"
          style={{
            background: "linear-gradient(135deg, #4e73df, #224abe)",
          }}
        >
          <div className="row align-items-center">
            <div className="col-md-3 text-center">
              <img
                src={logo}
                alt="Profile"
                className="rounded-circle border border-3 border-white shadow"
                style={{ width: "130px", height: "130px", objectFit: "cover" }}
              />
            </div>
            <div className="col-md-9">
              <h2 className="fw-bold mb-0">{user.name}</h2>
              <p className="mb-1">{user.email}</p>
              <span className="badge bg-light text-dark">{user.role}</span>
            </div>
          </div>
        </div>

        {/* Stats Row */}
        {/* <div className="row text-center mb-4">
          <div className="col-md-4 mb-3">
            <div className="p-3 rounded shadow-sm bg-light">
              <h5 className="fw-bold">10</h5>
              <small className="text-muted">Projects</small>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="p-3 rounded shadow-sm bg-light">
              <h5 className="fw-bold">20</h5>
              <small className="text-muted">Tasks Completed</small>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="p-3 rounded shadow-sm bg-light">
              <h5 className="fw-bold">1</h5>
              <small className="text-muted">Meetings</small>
            </div>
          </div>
        </div> */}

        {/* Details Section */}
        <div className="card shadow-sm border-0">
          <div className="card-header bg-white fw-bold fs-5">
            Profile Details
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-sm-4 text-muted">Full Name</div>
              <div className="col-sm-8">{user.name}</div>
            </div>
            <div className="row mb-3">
              <div className="col-sm-4 text-muted">Email</div>
              <div className="col-sm-8">{user.email}</div>
            </div>
            <div className="row mb-3">
              <div className="col-sm-4 text-muted">Phone</div>
              <div className="col-sm-8">{user.phone}</div>
            </div>
            <div className="row mb-3">
              <div className="col-sm-4 text-muted">Role</div>
              <div className="col-sm-8">{user.role}</div>
            </div>
            {/* <div className="row">
              <div className="col-sm-4 text-muted">Joined</div>
              <div className="col-sm-8">
                {new Date(user.joinDate).toLocaleDateString()}
              </div>
            </div> */}
          </div>
        </div>

        {/* Action Buttons */}
        {/* <div className="text-end mt-4">
          <button
            className="btn btn-primary me-2"
            onClick={() => navigate("/admin/edit-profile")}
          >
            Edit Profile
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate("/admin/dashboard")}
          >
            Back to Dashboard
          </button>
        </div> */}
      </div>
    </DashboardLayout>
  );
}

export default MyProfile;
